import React from "react";

const FONT = "'Plus Jakarta Sans', sans-serif";

const COLORS = {
  ink: "#23272f",
  muted: "#7c8593",
  cta: "#557c2e",
  chipBg: "#eef3e6",
  oliveDark: "#5c6a3c",
};

const CartEmptyState = ({ onContinueShopping }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ padding: "48px 36px", gap: "4px", minHeight: "55vh" }}
    >
      {/* Basket icon */}
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: "92px",
          height: "92px",
          borderRadius: "50%",
          background: COLORS.chipBg,
          color: COLORS.oliveDark,
          marginBottom: "10px",
        }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        >
          <circle cx="9" cy="20" r="1.4" />
          <circle cx="18" cy="20" r="1.4" />
          <path d="M2 3h3l2.4 12.4a1 1 0 001 .8h9.2a1 1 0 001-.8L21 7H6" />
        </svg>
      </div>

      <h3
        style={{
          fontSize: "19px",
          fontWeight: 800,
          color: COLORS.ink,
          fontFamily: FONT,
        }}
      >
        Your basket's feeling light 🥬
      </h3>
      <p
        style={{
          fontSize: "13.5px",
          color: COLORS.muted,
          fontWeight: 600,
          lineHeight: 1.5,
          maxWidth: "280px",
          marginTop: "2px",
          fontFamily: FONT,
        }}
      >
        Fresh things happen when you start adding. Let's fill it up.
      </p>

      <button
        onClick={onContinueShopping}
        style={{
          marginTop: "16px",
          background: COLORS.cta,
          color: "#fff",
          border: "none",
          borderRadius: "13px",
          padding: "14px 30px",
          fontFamily: FONT,
          fontWeight: 800,
          fontSize: "15px",
          cursor: "pointer",
        }}
      >
        Start shopping
      </button>
    </div>
  );
};

export default CartEmptyState;
